/* Arreglos de imagen en el navegador · Imprimirlo
 * Dos herramientas que convierten un aviso en una solución:
 *   ImgArreglo.quitarFondo(imagen)  -> borra el fondo liso de un JPG/PNG
 *   ImgArreglo.afinarBordes(imagen) -> amplía y limpia los bordes dentados
 * No suben nada a ningún sitio: todo pasa en el ordenador del cliente.
 */
(function () {
  'use strict';

  function lienzo(w, h) {
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h));
    return c;
  }
  function pintar(img) {
    var c = lienzo(img.width, img.height);
    c.getContext('2d', { willReadFrequently: true }).drawImage(img, 0, 0);
    return c;
  }
  function datos(c) {
    return c.getContext('2d', { willReadFrequently: true }).getImageData(0, 0, c.width, c.height);
  }

  /* ---------- color de fondo ----------
     Se mira el marco de la imagen: si casi todo el borde es del mismo color,
     ese es el fondo. Así no confundimos el blanco de dentro de un logo. */
  function colorDelBorde(d) {
    var p = d.data, w = d.width, h = d.height;
    var cubos = {}, total = 0;
    function mete(i) {
      if (p[i + 3] < 8) { total++; return; } // ya transparente: también es fondo
      var k = (p[i] >> 4) + ',' + (p[i + 1] >> 4) + ',' + (p[i + 2] >> 4);
      var c = cubos[k] || (cubos[k] = { n: 0, r: 0, g: 0, b: 0 });
      c.n++; c.r += p[i]; c.g += p[i + 1]; c.b += p[i + 2]; total++;
    }
    var paso = Math.max(1, Math.round(Math.max(w, h) / 400));
    for (var x = 0; x < w; x += paso) { mete((x) * 4); mete(((h - 1) * w + x) * 4); }
    for (var y = 0; y < h; y += paso) { mete((y * w) * 4); mete((y * w + w - 1) * 4); }
    var mejor = null;
    Object.keys(cubos).forEach(function (k) {
      if (!mejor || cubos[k].n > mejor.n) mejor = cubos[k];
    });
    if (!mejor) return { r: 255, g: 255, b: 255, parte: 1 };
    return {
      r: mejor.r / mejor.n, g: mejor.g / mejor.n, b: mejor.b / mejor.n,
      parte: mejor.n / Math.max(1, total)
    };
  }

  /* ---------- quitar el fondo ----------
     Relleno por inundación desde los bordes: solo desaparece el fondo que
     toca el marco, nunca un hueco blanco de dentro del dibujo.
     Dos tolerancias: hasta t1 se borra del todo, entre t1 y t2 se deja
     medio transparente para que el contorno no quede a escalones. */
  function quitarFondo(img, op) {
    op = op || {};
    var t1 = op.t1 == null ? 62 : op.t1, t2 = op.t2 == null ? 132 : op.t2;
    /* Cuánto del marco tiene que ser del mismo color para creer que es un
       fondo. Al 55 % se rechaza una foto a sangre, que es lo que se quiere…
       pero también un blanco con un degradado suave o con viñeta de cámara,
       que es como llega la mitad de los logos. Cuando el cliente pide «quitar
       más», esto baja con la tolerancia: él ya nos está diciendo que ahí hay
       un fondo, aunque no sea plano. */
    var minParte = op.minParte == null ? 0.55 : op.minParte;
    var c = img.getContext ? img : pintar(img);
    var d = datos(c), p = d.data, w = d.width, h = d.height;
    var fondo = colorDelBorde(d);
    // si el marco es un batiburrillo (una foto a sangre), no hay fondo que quitar
    if (fondo.parte < minParte) return { ok: false, motivo: 'sin-fondo' };

    var n = w * h;
    var visto = new Uint8Array(n);
    var pila = new Int32Array(n);
    var tope = 0, borrados = 0;

    function dist(i) {
      var dr = p[i * 4] - fondo.r, dg = p[i * 4 + 1] - fondo.g, db = p[i * 4 + 2] - fondo.b;
      return Math.sqrt(dr * dr + dg * dg + db * db);
    }
    function empuja(i) {
      if (visto[i]) return;
      if (p[i * 4 + 3] < 8) { visto[i] = 1; pila[tope++] = i; return; }
      if (dist(i) > t2) return;
      visto[i] = 1; pila[tope++] = i;
    }
    for (var x = 0; x < w; x++) { empuja(x); empuja((h - 1) * w + x); }
    for (var y = 0; y < h; y++) { empuja(y * w); empuja(y * w + w - 1); }

    while (tope > 0) {
      var i = pila[--tope];
      var a = p[i * 4 + 3];
      if (a >= 8) {
        var dd = dist(i);
        if (dd <= t1) { p[i * 4 + 3] = 0; borrados++; }
        else {
          // borde suave: se queda a medias y no seguimos por aquí
          p[i * 4 + 3] = Math.round(a * Math.min(1, (dd - t1) / (t2 - t1)));
          continue;
        }
      }
      var xi = i % w, yi = (i - xi) / w;
      if (xi > 0) empuja(i - 1);
      if (xi < w - 1) empuja(i + 1);
      if (yi > 0) empuja(i - w);
      if (yi < h - 1) empuja(i + w);
    }
    if (borrados / n < 0.02) return { ok: false, motivo: 'sin-fondo' };

    /* ¿HEMOS QUITADO UN FONDO O HEMOS AGUJEREADO EL DISEÑO?
       Cuando el color del fondo está TAMBIÉN dentro del dibujo —una portada
       sobre negro, con negro entre las letras y entre los adornos— el relleno
       se cuela por esos huecos y deja el diseño hecho un colador. Se ve en un
       número: si lo que queda sigue ocupando casi todo el archivo, es que lo
       borrado no rodeaba nada, estaba por dentro.
         portada de disco sobre negro ... 92 %  -> se rechaza
         logo sobre blanco / negro / rojo  50 %
         foto de producto sobre blanco ... 25-32 %
       El cliente prefiere mil veces que le digamos «este no se puede» a
       recibir mil pegatinas agujereadas. */
    var mnX = w, mnY = h, mxX = -1, mxY = -1;
    for (var yy = 0; yy < h; yy++) {
      for (var xx = 0; xx < w; xx++) {
        if (p[(yy * w + xx) * 4 + 3] < 128) continue;
        if (xx < mnX) mnX = xx;
        if (xx > mxX) mxX = xx;
        if (yy < mnY) mnY = yy;
        if (yy > mxY) mxY = yy;
      }
    }
    if (mxX < 0) return { ok: false, motivo: 'sin-fondo' };
    var encuadre = ((mxX - mnX + 1) * (mxY - mnY + 1)) / n;
    if (encuadre >= 0.85) return { ok: false, motivo: 'mezclado' };

    // el fondo tiñe el contorno: se le quita esa mezcla a los píxeles del borde
    desteñir(d, fondo);
    var salida = lienzo(w, h);
    salida.getContext('2d').putImageData(d, 0, 0);
    return { ok: true, lienzo: salida, parte: borrados / n, color: fondo };
  }

  // quita el halo del color de fondo en los píxeles semitransparentes
  function desteñir(d, f) {
    var p = d.data;
    for (var i = 0; i < p.length; i += 4) {
      var a = p[i + 3];
      if (a === 0 || a === 255) continue;
      var k = a / 255;
      p[i] = Math.max(0, Math.min(255, (p[i] - f.r * (1 - k)) / k));
      p[i + 1] = Math.max(0, Math.min(255, (p[i + 1] - f.g * (1 - k)) / k));
      p[i + 2] = Math.max(0, Math.min(255, (p[i + 2] - f.b * (1 - k)) / k));
    }
  }

  /* ---------- ¿es un logo de colores planos? ----------
     Solo en esos casos tiene sentido afinar bordes; en una foto no. */
  function esPlano(img) {
    var c = img.getContext ? img : pintar(img);
    var ancho = Math.min(c.width, 240);
    var chico = lienzo(ancho, Math.max(1, Math.round(c.height * ancho / c.width)));
    chico.getContext('2d').drawImage(c, 0, 0, chico.width, chico.height);
    var p = datos(chico).data, cuenta = {}, vistos = 0;
    for (var i = 0; i < p.length; i += 4) {
      if (p[i + 3] < 24) continue;
      var k = (p[i] >> 4) * 289 + (p[i + 1] >> 4) * 17 + (p[i + 2] >> 4);
      cuenta[k] = (cuenta[k] || 0) + 1; vistos++;
    }
    if (!vistos) return false;
    var fuertes = 0;
    Object.keys(cuenta).forEach(function (k) { if (cuenta[k] / vistos > 0.004) fuertes++; });
    return fuertes <= 26;
  }

  /* ---------- el fondo negro ES la tela ----------
   *
   * El caso: arte de grupo, cartel o portada de disco. Viene sobre un
   * rectángulo NEGRO, y el dibujo no acaba en un borde: se apaga dentro del
   * negro con brillos y sombras.
   *
   * Si eso se imprime tal cual sobre tela oscura, el RIP mete blanco debajo de
   * todo lo que no sea transparente del todo y sale un pegote negro sobre tela
   * negra. Es el peor resultado posible y además el más caro. Y no hablamos
   * solo de camisetas: un transfer se plancha igual en una bolsa, un delantal
   * o una gorra.
   *
   * Lo correcto es que el negro NO se imprima: que sea la tela. Y no vale
   * con recortar un fondo plano, porque no hay un borde que recortar — hay un
   * fundido. Lo que se hace es convertir el brillo en OPACIDAD:
   *
   *   alfa  = lo que el negro no ha apagado (el canal más alto del píxel)
   *   color = el original dividido por ese alfa, para que el oro siga siendo
   *           oro y no salga lavado
   *
   * Compuesto otra vez sobre negro da EXACTAMENTE la imagen de partida: no se
   * inventa nada, solo se reparte entre color y transparencia. Y lo que queda
   * a medias es justo lo que sabe tramar el panel de producción a 300 ppp.
   *
   * Esto sí se puede hacer en el navegador porque es cuenta por píxel: no
   * depende de la resolución del archivo. La trama no, y por eso no está aquí.
   */

  /* ¿Viene sobre negro? Mucha superficie casi negra y sin transparencia. Si el
     archivo ya trae alfa, el diseñador ya lo resolvió y no hay que tocarlo. */
  function pideFundirNegro(img) {
    var c = img.getContext ? img : pintar(img);
    var ancho = Math.min(c.width, 260);
    var chico = lienzo(ancho, Math.max(1, Math.round(c.height * ancho / c.width)));
    chico.getContext('2d').drawImage(c, 0, 0, chico.width, chico.height);
    var p = datos(chico).data, n = 0, negros = 0, transp = 0;
    for (var i = 0; i < p.length; i += 4) {
      n++;
      if (p[i + 3] < 250) { transp++; continue; }
      if (Math.max(p[i], p[i + 1], p[i + 2]) < 24) negros++;
    }
    if (!n || transp / n > 0.02) return false;
    if (negros / n < 0.22) return false;
    /* Que haya mucho negro no basta: un logo NEGRO sobre fondo blanco (Quiksilver,
       un escudo, un texto) también tiene más del 22 % de negro, y ese negro es
       el dibujo, no la tela. Un fondo negro se nota en las ESQUINAS: si al menos
       tres de las cuatro son claras, el negro es el diseño y no se funde. */
    var w = chico.width, h = chico.height, m = Math.max(2, Math.round(Math.min(w, h) * 0.07)), oscuras = 0;
    [[0, 0], [w - m, 0], [0, h - m], [w - m, h - m]].forEach(function (e) {
      var s = 0, k = 0;
      for (var y = e[1]; y < e[1] + m; y++) for (var x = e[0]; x < e[0] + m; x++) { var o = (y * w + x) * 4; s += Math.max(p[o], p[o + 1], p[o + 2]); k++; }
      if (k && s / k < 70) oscuras++;
    });
    return oscuras >= 2;
  }

  /* "piso" es el ruido del negro que se da por fondo: un JPG nunca tiene el
     negro a cero limpio, y sin este suelo quedaría una neblina de tinta por
     todo el rectángulo.
     EL SUELO LO PONE EL ARCHIVO, NO NOSOTROS. Estaba clavado en 6 y eso no es
     un negro: es UN negro concreto. El escudo de WarCry que manda un cliente
     de verdad trae el fondo en (8,4,9) —negrísimo a la vista, pero por encima
     del 6—, así que no se iba ni un píxel y el arreglo contestaba que no había
     negro que fundir… después de haber ofrecido el botón, porque la sonda mira
     por debajo de 24 y el trabajo miraba por debajo de 6. Dos varas de medir
     para la misma pregunta.
     Ahora se mide: el fondo es la mancha oscura más grande del archivo, así que
     el percentil 8 del brillo cae DENTRO de ella, y con dos puntos de margen se
     lleva también el ruido de compresión. El tope de 30 es para no empezar a
     comerse las sombras del dibujo. Si el archivo trae el negro limpio a cero,
     sale un suelo de 2-3 y se comporta como siempre. */
  function pisoNegro(c) {
    var ancho = Math.min(c.width, 260);
    var chico = lienzo(ancho, Math.max(1, Math.round(c.height * ancho / c.width)));
    chico.getContext('2d').drawImage(c, 0, 0, chico.width, chico.height);
    var p = datos(chico).data, h = new Uint32Array(256), n = 0;
    for (var i = 0; i < p.length; i += 4) {
      if (p[i + 3] < 250) continue;
      h[Math.max(p[i], p[i + 1], p[i + 2])]++; n++;
    }
    if (!n) return 6;
    var meta = n * 0.08, acc = 0;
    for (var v = 0; v < 256; v++) {
      acc += h[v];
      if (acc >= meta) return Math.min(30, v + 2);
    }
    return 6;
  }

  /* ¿El archivo YA trae transparencia propia? (un PNG con el dibujo suelto, que es lo normal en
     un logo). Entonces el color de cada píxel es el verdadero y NO viene mezclado con negro: no se
     puede sacar el alfa del brillo. Pedido 1988 (16/10): un logo crema con "polvo" de alfa 1-25 salió
     con puntitos sólidos por todas partes, porque el alfa se rehacía con el brillo (crema = 252) y
     el polvo casi invisible pasaba a opaco. */
  function conAlfaPropio(p) {
    var n = p.length / 4, t = 0;
    for (var i = 3; i < p.length; i += 4) if (p[i] < 250) t++;
    return t / n > 0.02;
  }

  function fundirNegro(img, piso) {
    var c = img.getContext ? img : pintar(img);
    var d = datos(c), p = d.data;
    var s = piso == null ? pisoNegro(c) : piso, k = 255 / (255 - s);
    var fuera = 0;
    if (conAlfaPropio(p)) {
      /* Prenda negra: lo semitransparente se «aplana» sobre el negro de la prenda (color = color × alfa) y pasa a tinta opaca; lo que
         queda casi negro (< 30-45 de brillo, que incluye el polvo de alfa 1-25 y las sombras) se deja sin tinta. Así las líneas finas
         y tenues de un mapa o un boceto salen como se verían sobre la camiseta, en gris, y no como líneas blancas gruesas. Lo opaco
         no cambia. (Pedido 1988, espalda: curvas de nivel de alfa 20-40 % que la versión anterior pasaba a blanco pleno.) */
      for (var j = 0; j < p.length; j += 4) {
        var al = p[j + 3];
        if (!al) continue;
        var cr = p[j] * al / 255, cg = p[j + 1] * al / 255, cb = p[j + 2] * al / 255;
        var mx = Math.max(cr, cg, cb);
        var f = mx <= 30 ? 0 : mx < 45 ? (mx - 30) / 15 : 1;
        if (f <= 0) { p[j + 3] = 0; fuera++; continue; }
        p[j] = Math.round(cr); p[j + 1] = Math.round(cg); p[j + 2] = Math.round(cb);
        p[j + 3] = al < 250 ? Math.round(255 * f) : Math.round(al * f);
      }
      var sal = lienzo(c.width, c.height);
      sal.getContext('2d').putImageData(d, 0, 0);
      return { ok: true, lienzo: sal, parte: fuera / (p.length / 4), piso: s };
    }
    /* Archivo OPACO (un JPG, o un PNG sin transparencia) con fondo negro: el alfa sale de lo que el negro no apaga y el color
       se des-premultiplica (vuelve a ser el que era antes del negro). Este bucle se perdió por error el 23/10/2026 al añadir la
       rama del alfa propio: sin él, todo archivo opaco caía en el umbral duro del editor y salía con los bordes rotos. */
    for (var i = 0; i < p.length; i += 4) {
      var a = Math.max(p[i], p[i + 1], p[i + 2]);
      a = (a - s) * k;
      if (a <= 0) { p[i + 3] = 0; fuera++; continue; }
      if (a > 255) a = 255;
      var f = 255 / a;
      p[i] = Math.min(255, p[i] * f);
      p[i + 1] = Math.min(255, p[i + 1] * f);
      p[i + 2] = Math.min(255, p[i + 2] * f);
      p[i + 3] = Math.round(a);
    }
    var n = p.length / 4;
    if (fuera / n < 0.05) return { ok: false, motivo: 'sin-negro' };
    var salida = lienzo(c.width, c.height);
    salida.getContext('2d').putImageData(d, 0, 0);
    return { ok: true, lienzo: salida, parte: fuera / n, piso: s };
  }

  /* ---------- afinar bordes ----------
     Amplía con suavizado y después vuelve a apretar el contorno. No inventa
     detalle: lo que hace es que los dientes de sierra dejen de verse. */
  function afinarBordes(img, escala) {
    var c = img.getContext ? img : pintar(img);
    var e = escala || 3;
    var max = 3200; // que no se dispare la memoria en móviles
    if (c.width * e > max) e = Math.max(1, max / c.width);
    if (e <= 1.05) return { ok: false, motivo: 'ya-grande' };

    var g = lienzo(c.width * e, c.height * e);
    var gx = g.getContext('2d', { willReadFrequently: true });
    gx.imageSmoothingEnabled = true; gx.imageSmoothingQuality = 'high';
    gx.drawImage(c, 0, 0, g.width, g.height);

    var d = datos(g);
    contraste(d, 1.9);      // contorno del alfa más limpio
    enfocar(d, 0.55);       // un punto de nitidez en el color
    var salida = lienzo(g.width, g.height);
    salida.getContext('2d').putImageData(d, 0, 0);
    return { ok: true, lienzo: salida, escala: e };
  }

  // curva en S sobre el alfa: el contorno deja de estar "lavado"
  function contraste(d, k) {
    var p = d.data;
    for (var i = 3; i < p.length; i += 4) {
      var a = p[i] / 255;
      if (a <= 0 || a >= 1) continue;
      p[i] = Math.round(255 * Math.max(0, Math.min(1, (a - 0.5) * k + 0.5)));
    }
  }

  // máscara de enfoque sencilla (original + diferencia con el desenfoque)
  function enfocar(d, fuerza) {
    var p = d.data, w = d.width, h = d.height;
    var copia = new Uint8ClampedArray(p);
    for (var y = 1; y < h - 1; y++) {
      for (var x = 1; x < w - 1; x++) {
        var i = (y * w + x) * 4;
        if (copia[i + 3] < 8) continue;
        for (var ch = 0; ch < 3; ch++) {
          var s = 0;
          s += copia[i - w * 4 + ch] + copia[i + w * 4 + ch] + copia[i - 4 + ch] + copia[i + 4 + ch];
          s += copia[i - w * 4 - 4 + ch] + copia[i - w * 4 + 4 + ch] + copia[i + w * 4 - 4 + ch] + copia[i + w * 4 + 4 + ch];
          var media = (s + copia[i + ch]) / 9;
          p[i + ch] = Math.max(0, Math.min(255, copia[i + ch] + fuerza * (copia[i + ch] - media)));
        }
      }
    }
  }

  /* ---------- dónde ha cambiado la imagen ----------
     Sin esto el recorte sale del centro, y en un CD o una etiqueta redonda el
     cambio está en el borde: el cliente ve dos imágenes idénticas y no se cree
     que hayamos hecho nada. Se compara en pequeño y se busca la ventana con
     más diferencia. Devuelve la esquina del recorte en píxeles del original. */
  function zonaDelCambio(o, r, rw, rh) {
    var n = 72, nh = Math.max(1, Math.round(n * o.height / o.width));
    var ca = lienzo(n, nh), cb = lienzo(n, nh);
    var xa = ca.getContext('2d'), xb = cb.getContext('2d');
    xa.imageSmoothingEnabled = true; xb.imageSmoothingEnabled = true;
    xa.drawImage(o, 0, 0, n, nh);
    xb.drawImage(r, 0, 0, n, nh);
    var A = datos(ca).data, B = datos(cb).data;

    /* Mapa de "esto ha cambiado, esto no". El alfa pesa el doble porque
       quitar el fondo solo toca la transparencia. */
    var cambiado = new Uint8Array(n * nh), tocados = 0;
    for (var i = 0; i < n * nh; i++) {
      var j = i * 4;
      var d = Math.abs(A[j + 3] - B[j + 3]) * 2 +
        Math.abs(A[j] - B[j]) + Math.abs(A[j + 1] - B[j + 1]) + Math.abs(A[j + 2] - B[j + 2]);
      if (d > 30) { cambiado[i] = 1; tocados++; }
    }
    var gw = Math.max(1, Math.min(n, Math.round(rw * n / o.width)));
    var gh = Math.max(1, Math.min(nh, Math.round(rh * nh / o.height)));
    var cx = (n - gw) / 2, cy = (nh - gh) / 2;
    if (!tocados) return { x: cx, y: cy };

    // suma acumulada para mirar todas las ventanas sin que cueste
    var S = new Int32Array((n + 1) * (nh + 1));
    for (var y = 0; y < nh; y++) {
      for (var x = 0; x < n; x++) {
        S[(y + 1) * (n + 1) + x + 1] = cambiado[y * n + x] +
          S[y * (n + 1) + x + 1] + S[(y + 1) * (n + 1) + x] - S[y * (n + 1) + x];
      }
    }
    /* Se elige la ventana donde MÁS conviven las dos cosas (c × (total − c)),
       no la que más cambio tiene: así el recorte cae sobre la frontera y se ve
       el antes y el después de verdad, en vez de un cuadro de damero entero. */
    var mejor = -1, bx = cx, by = cy, celdas = gw * gh;
    for (var y2 = 0; y2 + gh <= nh; y2++) {
      for (var x2 = 0; x2 + gw <= n; x2++) {
        var c = S[(y2 + gh) * (n + 1) + x2 + gw] - S[y2 * (n + 1) + x2 + gw] -
          S[(y2 + gh) * (n + 1) + x2] + S[y2 * (n + 1) + x2];
        var s = c * (celdas - c);
        if (s > mejor) { mejor = s; bx = x2; by = y2; }
      }
    }
    if (mejor <= 0) return { x: cx, y: cy };
    return { x: bx * o.width / n, y: by * o.height / nh };
  }

  /* ---------- antes y después ----------
     Se recorta el trozo donde está el cambio y se amplía, así se aprecia.
     A propósito NO se enseña la imagen entera ni a tamaño real: esto es una
     comprobación, no un editor de fotos. */
  function comparar(origen, resultado, w, h, fraccion) {
    w = w || 300; h = h || 210;
    var o = origen.getContext ? origen : pintar(origen);
    var rw = Math.max(8, Math.round(o.width * (fraccion || 0.5)));
    var rh = Math.max(8, Math.round(rw * h / w));
    if (rh > o.height) { rh = o.height; rw = Math.max(8, Math.round(rh * w / h)); }
    if (rw > o.width) rw = o.width;

    var z = zonaDelCambio(o, resultado, rw, rh);
    var rx = Math.max(0, Math.min(o.width - rw, Math.round(z.x)));
    var ry = Math.max(0, Math.min(o.height - rh, Math.round(z.y)));

    function corte(src, esc) {
      var c = lienzo(w, h);
      var cx = c.getContext('2d');
      cx.imageSmoothingEnabled = true; cx.imageSmoothingQuality = 'high';
      cx.drawImage(src, rx * esc, ry * esc, rw * esc, rh * esc, 0, 0, w, h);
      return c;
    }
    return { antes: corte(o, 1), despues: corte(resultado, resultado.width / o.width) };
  }

  /* ---------- SEMITONO, PARA ENSEÑARLO ----------
   *
   * Xavi quiere vender el semitono como una ventaja, y para eso el cliente
   * tiene que VERLO: el fundido en pantalla es un degradado suave que no se
   * parece a lo que sale de la plancha. Lo que sale son puntos: la opacidad
   * a medias se convierte en puntos de tinta más grandes o más pequeños, en
   * una retícula girada 45°, y entre punto y punto se ve la tela.
   *
   * Esto es SOLO para la vista ampliada. El archivo que va a producción no
   * se toca: la trama de verdad la hace el taller a 300 ppp (el pedido lleva
   * «TRAMAR puntos45»). `celda` es el paso de la retícula en píxeles de
   * pantalla, calculado a escala del tamaño pedido. */
  function tramar(img, celda) {
    var c = img.getContext ? img : pintar(img);
    var out = lienzo(c.width, c.height);
    out.getContext('2d').drawImage(c, 0, 0);
    var d = datos(out), p = d.data, W = out.width;
    var k = 2 * Math.PI / Math.max(2, celda), r = Math.SQRT1_2;
    var suave = Math.max(0.04, 1.2 / celda);
    for (var i = 0; i < p.length; i += 4) {
      var al = p[i + 3] / 255;
      if (al <= 0) continue;
      if (al >= 0.97) { p[i + 3] = 255; continue; }
      var x = (i / 4) % W, y = (i / 4 - x) / W;
      var u = (x + y) * r, v = (x - y) * r;
      var spot = (Math.cos(u * k) + Math.cos(v * k) + 2) / 4;   // 1 en el centro del punto
      var t = (spot - (1 - al)) / suave + 0.5;
      p[i + 3] = t <= 0 ? 0 : t >= 1 ? 255 : Math.round(t * 255);
    }
    out.getContext('2d').putImageData(d, 0, 0);
    return out;
  }

  /* La vista «Tal cual / Con semitono» A ESCALA de la medida pedida: una
     ventana de unos 4 cm reales y la retícula del taller encima. Se guarda
     de dónde sale (origen, resultado) para rehacerla si cambia el tamaño:
     el punto mide siempre lo mismo en la tela, así que a 8 cm se ven pocos
     puntos gordos por detalle y a 25 cm muchos más finos (Xavi, 26/09). */
  function vistaSemitono(origen, resultado, mmW, w, h, tramaMm) {
    w = w || 300; h = h || 210;
    mmW = Math.max(10, mmW || 100);
    var fr = Math.min(0.5, 40 / mmW);
    var comp = comparar(origen, resultado, w, h, fr);
    comp.despues = tramar(comp.despues, w / (mmW * fr) * (tramaMm || 25.4 / 45));
    comp.semitono = true; comp.mm = mmW;
    comp.origen = origen; comp.resultado = resultado; comp.w = w; comp.h = h; comp.tramaMm = tramaMm;
    return comp;
  }

  /* MARGEN LISO (Xavi, 26/09: «cropar todo el negro o blanco
     automáticamente»). Recibe los píxeles de un archivo SIN transparencia y
     dice dónde acaba el margen si el borde entero es de un color liso
     (blanco, negro o el que sea, con la tolerancia del ruido de un JPG).
     Devuelve la caja de lo que hay dentro, con dos píxeles de respiro para
     no morder el antialias, o null si no hay margen que merezca quitarse. */
  function margenLiso(d, cw, ch) {
    var borde = [], bx, by, TOL = 28;
    var mete = function (xx, yy) { var k = (yy * cw + xx) * 4; borde.push([d[k], d[k + 1], d[k + 2]]); };
    for (bx = 0; bx < cw; bx++) { mete(bx, 0); mete(bx, ch - 1); }
    for (by = 0; by < ch; by++) { mete(0, by); mete(cw - 1, by); }
    var med = [0, 1, 2].map(function (q) {
      var v = borde.map(function (px) { return px[q]; }).sort(function (m, n) { return m - n; });
      return v[v.length >> 1];
    });
    var cerca = function (r, g, b) {
      return Math.abs(r - med[0]) <= TOL && Math.abs(g - med[1]) <= TOL && Math.abs(b - med[2]) <= TOL;
    };
    /* El fondo tiene que ser la mayor parte del borde, pero no todo: en un
       póster el título o unas llamas pueden tocar un lado y los otros tres
       seguir siendo margen. Por eso cada lado se recorta por su cuenta. */
    var iguales = borde.filter(function (px) { return cerca(px[0], px[1], px[2]); }).length;
    if (iguales / borde.length < 0.6) return null;
    // cuántos píxeles «de dibujo» hay en cada fila y en cada columna
    var fil = new Uint32Array(ch), col = new Uint32Array(cw);
    for (by = 0; by < ch; by++) for (bx = 0; bx < cw; bx++) {
      var k = (by * cw + bx) * 4;
      if (!cerca(d[k], d[k + 1], d[k + 2])) { fil[by]++; col[bx]++; }
    }
    // una fila es dibujo si tiene algo más que ruido de JPG
    var minF = Math.max(2, cw * 0.003), minC = Math.max(2, ch * 0.003);
    var y0 = 0, y1 = ch - 1, x0 = 0, x1 = cw - 1;
    while (y0 < ch && fil[y0] < minF) y0++;
    while (y1 > y0 && fil[y1] < minF) y1--;
    while (x0 < cw && col[x0] < minC) x0++;
    while (x1 > x0 && col[x1] < minC) x1--;
    if (y0 >= ch || x0 >= cw) return null;
    // un margen de nada (menos de un 2 % en total por cada eje): no se toca
    if ((x1 - x0 + 1) >= cw * 0.98 && (y1 - y0 + 1) >= ch * 0.98) return null;
    return { x: Math.max(0, x0 - 2), y: Math.max(0, y0 - 2),
      X: Math.min(cw - 1, x1 + 2), Y: Math.min(ch - 1, y1 + 2), color: med };
  }

  /* ¿ES UNA FOTO DE LA PRENDA CON EL DISEÑO PUESTO? (Xavi, 26/09: «ahora
     que todo el mundo diseña sus camisetas con ChatGPT», con el caso de la
     Rehala Los Panini por WhatsApp: dos camisetas naranjas sobre gris.)
     Una foto así no se puede imprimir: lo que hay que planchar es el dibujo
     solo, no la tela de la foto. Se reconoce por tres cosas a la vez:
       · un color que domina el dibujo (la prenda: ≥30 %) y casi no toca el
         borde, porque la prenda está recortada sobre un fondo;
       · y que ese color tiene SOMBRA y TEXTURA de tela (desviación de brillo
         y diferencias entre píxeles vecinos), que un logo plano no tiene.
     Medido: la foto de la Rehala da 0,45 / 0,01 / 7,2 / 1,47 (y recortada o
     comprimida por WhatsApp, lo mismo); una churrería a color 0,32 / 0 / 6,6 /
     0,4; una insignia naranja plana 0,56 / 0 / 0,9 / 0; nuestras previas
     dibujadas 0,39 / 0 / 4,0 / 0. No bloquea: avisa. */
  function pareceMockup(img, nombre) {
    var c = img.getContext ? img : pintar(img);
    var ancho = Math.min(c.width, 260);
    var ch = Math.max(1, Math.round(c.height * ancho / c.width)), cw = ancho;
    var chico = lienzo(cw, ch);
    chico.getContext('2d').drawImage(c, 0, 0, cw, ch);
    var d = datos(chico).data, n = cw * ch, i, x, y;
    for (i = 3; i < d.length; i += 4) if (d[i] < 250) return null;   // con transparencia: es un diseño
    var borde = [];
    var mete = function (xx, yy) { var k = (yy * cw + xx) * 4; borde.push([d[k], d[k + 1], d[k + 2]]); };
    for (x = 0; x < cw; x++) { mete(x, 0); mete(x, ch - 1); }
    for (y = 0; y < ch; y++) { mete(0, y); mete(cw - 1, y); }
    var med = [0, 1, 2].map(function (q) {
      var v = borde.map(function (px) { return px[q]; }).sort(function (m, o) { return m - o; });
      return v[v.length >> 1];
    });
    var dif = function (k, c3) { return Math.max(Math.abs(d[k] - c3[0]), Math.abs(d[k + 1] - c3[1]), Math.abs(d[k + 2] - c3[2])); };
    var cubos = {}, mejor = -1, cuenta = 0;
    for (i = 0; i < n; i++) {
      var k = i * 4;
      if (dif(k, med) <= 28) continue;
      var q = (d[k] >> 4) * 256 + (d[k + 1] >> 4) * 16 + (d[k + 2] >> 4);
      cubos[q] = (cubos[q] || 0) + 1;
      if (cubos[q] > cuenta) { cuenta = cubos[q]; mejor = q; }
    }
    if (mejor < 0) return null;
    var sr = 0, sg = 0, sb = 0, sn = 0;
    for (i = 0; i < n; i++) {
      var k2 = i * 4;
      if ((d[k2] >> 4) * 256 + (d[k2 + 1] >> 4) * 16 + (d[k2 + 2] >> 4) === mejor) { sr += d[k2]; sg += d[k2 + 1]; sb += d[k2 + 2]; sn++; }
    }
    var col = [sr / sn, sg / sn, sb / sn];
    var dom = new Uint8Array(n), lum = new Float32Array(n), nd = 0, nb = 0, suma = 0, suma2 = 0;
    for (i = 0; i < n; i++) {
      var k3 = i * 4;
      lum[i] = d[k3] * 0.299 + d[k3 + 1] * 0.587 + d[k3 + 2] * 0.114;
      if (dif(k3, med) > 28 && dif(k3, col) <= 40) { dom[i] = 1; nd++; suma += lum[i]; suma2 += lum[i] * lum[i]; }
    }
    var parte = nd / n;
    for (x = 0; x < cw; x++) { nb += dom[x] + dom[(ch - 1) * cw + x]; }
    for (y = 0; y < ch; y++) { nb += dom[y * cw] + dom[y * cw + cw - 1]; }
    var enBorde = nb / (2 * (cw + ch));
    var media = nd ? suma / nd : 0;
    var desv = nd ? Math.sqrt(Math.max(0, suma2 / nd - media * media)) : 0;
    // textura: mediana de la diferencia de brillo entre vecinos dentro de la prenda
    var hist = new Uint32Array(501), nt = 0;
    for (y = 0; y < ch; y++) for (x = 0; x < cw; x++) {
      var j = y * cw + x;
      if (!dom[j]) continue;
      if (x + 1 < cw && dom[j + 1]) { hist[Math.min(500, Math.round(Math.abs(lum[j] - lum[j + 1]) * 10))]++; nt++; }
      if (y + 1 < ch && dom[j + cw]) { hist[Math.min(500, Math.round(Math.abs(lum[j] - lum[j + cw]) * 10))]++; nt++; }
    }
    var tex = 0, acc = 0;
    for (i = 0; i <= 500; i++) { acc += hist[i]; if (acc >= nt / 2) { tex = i / 10; break; } }
    var prenda = parte >= 0.3 && enBorde < 0.1;
    var foto = desv >= 4.5 && tex >= 0.8;
    var porNombre = /chatgpt|dall[\s._-]?e|gemini[_ ]generated|mock-?up/i.test(nombre || '');
    var sale = prenda && (foto || porNombre);
    return { mockup: sale, parte: parte, enBorde: enBorde, desv: desv, tex: tex, porNombre: porNombre };
  }

  /* PNG CON SU TAMAÑO DE IMPRESIÓN DENTRO. Se añade el bloque pHYs (píxeles
     por metro) para que Photoshop o el panel lo abran ya a la medida del
     pedido, sin remuestrear: los píxeles son los del cliente, tal cual. */
  var TABLA_CRC = null;
  function crc32(bytes) {
    if (!TABLA_CRC) {
      TABLA_CRC = new Uint32Array(256);
      for (var n = 0; n < 256; n++) {
        var c = n;
        for (var k = 0; k < 8; k++) c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1;
        TABLA_CRC[n] = c >>> 0;
      }
    }
    var x = 0xFFFFFFFF;
    for (var i = 0; i < bytes.length; i++) x = TABLA_CRC[(x ^ bytes[i]) & 255] ^ (x >>> 8);
    return (x ^ 0xFFFFFFFF) >>> 0;
  }
  /* Un trozo (chunk) de PNG: longitud, tipo, datos y CRC. */
  function chunkPng(tipo, datos) {
    var out = new Uint8Array(12 + datos.length), dv = new DataView(out.buffer);
    dv.setUint32(0, datos.length);
    for (var i = 0; i < 4; i++) out[4 + i] = tipo.charCodeAt(i);
    out.set(datos, 8);
    dv.setUint32(8 + datos.length, crc32(out.subarray(4, 8 + datos.length)));
    return out;
  }
  function u32(v) { return [(v >>> 24) & 255, (v >>> 16) & 255, (v >>> 8) & 255, v & 255]; }

  /* El PNG con su medida (pHYs) Y con el color declarado como sRGB (sRGB + gAMA + cHRM). Sin eso el PNG no dice en qué espacio está:
     Photoshop, el RIP o el visor lo interpretan a su manera y puede salir oscuro o con colores raros (Xavi, 08/10: «los png del
     cojín me llegan con un perfil raro»). Se quita cualquier otro perfil que el navegador hubiera escrito (iCCP) para que no haya
     dos versiones. */
  function pngConMedida(c, mmW, nombre) {
    return new Promise(function (ok, mal) {
      c.toBlob(function (b) {
        if (!b) return mal(new Error('png'));
        b.arrayBuffer().then(function (buf) {
          var png = new Uint8Array(buf), ppm = Math.max(1, Math.round(c.width / (mmW / 1000)));
          var antes = [], resto = [], pos = 8, dv = new DataView(buf);
          var ihdr = png.subarray(0, 8 + 25);               // firma + IHDR (13 + 12)
          pos = 8 + 25;
          while (pos + 12 <= png.length) {
            var len = dv.getUint32(pos), tipo = String.fromCharCode(png[pos + 4], png[pos + 5], png[pos + 6], png[pos + 7]);
            var trozo = png.subarray(pos, pos + 12 + len);
            if (['iCCP', 'sRGB', 'gAMA', 'cHRM', 'pHYs'].indexOf(tipo) === -1) resto.push(trozo);
            pos += 12 + len;
          }
          var nuevos = [
            chunkPng('sRGB', new Uint8Array([0])),                                                        // intención perceptiva
            chunkPng('gAMA', new Uint8Array(u32(45455))),
            chunkPng('cHRM', new Uint8Array([].concat(u32(31270), u32(32900), u32(64000), u32(33000), u32(30000), u32(60000), u32(15000), u32(6000)))),
            chunkPng('pHYs', new Uint8Array([].concat(u32(ppm), u32(ppm), [1])))                          // por metro
          ];
          var total = ihdr.length, k;
          for (k = 0; k < nuevos.length; k++) total += nuevos[k].length;
          for (k = 0; k < resto.length; k++) total += resto[k].length;
          var out = new Uint8Array(total), o = 0;
          out.set(ihdr, o); o += ihdr.length;
          for (k = 0; k < nuevos.length; k++) { out.set(nuevos[k], o); o += nuevos[k].length; }
          for (k = 0; k < resto.length; k++) { out.set(resto[k], o); o += resto[k].length; }
          ok(new File([out], nombre, { type: 'image/png' }));
        }, mal);
      }, 'image/png');
    });
  }

  // canvas -> File, listo para el carrito
  function aFichero(c, nombre) {
    return new Promise(function (ok) {
      c.toBlob(function (b) {
        ok(new File([b], nombre, { type: 'image/png' }));
      }, 'image/png');
    });
  }

  /* CUÁNTO DEL DISEÑO ES OSCURO (brillo por debajo de 60), en tanto por uno.
     No mira el marco sino todo el dibujo: una portada de disco escaneada tiene
     el negro «levantado» —grises de 25 a 60, no negro de verdad— y repartido
     por todo el dibujo, no alrededor. Para `pideFundirNegro` eso no es un
     recuadro negro, pero sobre una camiseta negra sigue siendo lo que hay que
     fundir con la prenda y tramar. */
  function parteOscura(img) {
    var c = img.getContext ? img : pintar(img);
    var ancho = Math.min(c.width, 260);
    var chico = lienzo(ancho, Math.max(1, Math.round(c.height * ancho / c.width)));
    chico.getContext('2d').drawImage(c, 0, 0, chico.width, chico.height);
    var p = datos(chico).data, n = 0, osc = 0;
    for (var i = 0; i < p.length; i += 4) {
      if (p[i + 3] < 250) continue;
      n++;
      if (Math.max(p[i], p[i + 1], p[i + 2]) < 60) osc++;
    }
    return n ? osc / n : 0;
  }

  /* El color que domina el marco del archivo. Lo usa la ficha para saber si
     un fondo es CLARO antes de ofrecer «Eliminar blanco de fondo». */
  function colorBorde(img) {
    var c = img.getContext ? img : pintar(img);
    return colorDelBorde(datos(c));
  }

  window.ImgArreglo = {
    colorBorde: colorBorde,
    parteOscura: parteOscura,
    tramar: tramar,
    vistaSemitono: vistaSemitono,
    pngConMedida: pngConMedida,
    margenLiso: margenLiso,
    pareceMockup: pareceMockup,
    quitarFondo: quitarFondo,
    afinarBordes: afinarBordes,
    esPlano: esPlano,
    fundirNegro: fundirNegro,
    pideFundirNegro: pideFundirNegro,
    comparar: comparar,
    aFichero: aFichero
  };
})();